import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { isMobile } from 'react-device-detect';

import Sponsor from "./sponsors/sponsor"
import ImageSponsor from "./sponsors/sponsor-image"
import TextSponsor from "./sponsors/sponsor-text"

const Sponsors = styled.div`
    display: flex;
    flex-flow: wrap;
    justify-content: center;

    > div {
        margin: 3px;
    }
`
const Heading = styled.h3`
    margin-bottom: 25px;
    text-align: center;
`

function SponsorsGrid({type, sponsors}) {
    return (
        <>
        {sponsors.map((sponsor, index) => (
            <Sponsor key={index} type={type || ""}>    
                {sponsor.text ? 
                    <TextSponsor sponsor={sponsor} />
                : 
                    <ImageSponsor sponsor={sponsor} />
                }
            </Sponsor>
        ))} 
        </>      
    )
}

function SponsorsListing({heading, sponsors}) {
    const [levels, setLevels] = useState([]);

    useEffect(() => {
        const data = [];

        for (var i=1; i<=10; i++) {
            const levelSponsors = sponsors.filter(p => p.level == i);

            if (levelSponsors.length > 0) {
                data.push({
                    number: i,
                    sponsors: levelSponsors
                });
            }
        }

        setLevels(data);
      }, [sponsors]);

    return (
        <>
            <Heading>{heading || "Sponsored By"}</Heading>
                
            {levels.map(level => (
                <div key={level.number} style={{marginBottom: "20px"}}>
                    <Sponsors>
                        <SponsorsGrid 
                            type={"level"+level.number} 
                            sponsors={level.sponsors} 
                        />
                    </Sponsors>
                </div>
            ))}
        </>
    );
}

export default SponsorsListing;